import { render, staticRenderFns } from "./BaseCreditCardIcon.vue?vue&type=template&id=4aa1ce9e"
import script from "./BaseCreditCardIcon.vue?vue&type=script&lang=js"
export * from "./BaseCreditCardIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports